"use client";

import Link from "next/link";

import { NotificationBar } from "@saas/shared/ui/notification-bar/notification-bar";

export interface IUnverifiedPhoneNotificationBarProps {
  segment?: string | null;
  testid?: string;
}

export const UnverifiedPhoneNotificationBar = ({
  testid,
  segment,
}: IUnverifiedPhoneNotificationBarProps) => {
  const isOnAccountPage = segment === "account";

  return (
    <div className={"mt-4 mb-6"}>
      <NotificationBar
        title={"Verifikasi Nomor Telepon"}
        message={
          <span
            className={"body-b2 text-he flex flex-col gap-2"}
            data-testid={`${testid}__text__description`}
          >
            Verifikasi nomor telepon kamu untuk klaim dan menggunakan voucher.
            {!isOnAccountPage ? (
              <Link
                href={"/account"}
                className={"text-blue-B800 flex items-center text-sm font-bold"}
                data-testid={`${testid}__text__redirect`}
              >
                Ke Halaman Akun
              </Link>
            ) : null}
          </span>
        }
        variant={"info"}
        testid={testid}
      />
    </div>
  );
};
